import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/aagr-calculator',
  component: () => import('../../routes/AagrCalculator.svelte'),
  card: {
    id: 'aagr-calculator',
    title: 'AAGR Calculator',
    description:
      'Calculate the Average Annual Growth Rate (AAGR) from a series of yearly values. See year-by-year growth rates and project future values.',
    icon: 'trending_up',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/aagr-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'AAGR Calculator – Average Annual Growth Rate Calculator',
    description:
      'Free AAGR calculator to calculate the average annual growth rate from yearly values. Enter your revenue, investment, or sales data to find AAGR, year-by-year growth rates, and future projections. Compare AAGR vs CAGR.',
  },
};

export default meta;
